import { PopupsStore } from '@gamiphy/loyalty-station-desktop/store/popups';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import PopupContent from './PopupContent';

const CenteredPopupContent = observer(() => {
  const isMobile = useMobile();

  return (
    PopupsStore.activePopup && (
      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: PopupsStore.activePopup?.overlayEffect ? 'rgba(0,0,0,0.2)' : 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <PopupContent isMobile={isMobile} popup={PopupsStore.activePopup} />
      </Box>
    )
  );
});

export default CenteredPopupContent;
